import { render, staticRenderFns } from "./TablePromotions.vue?vue&type=template&id=559544cc&scoped=true&"
import script from "./TablePromotions.vue?vue&type=script&lang=js&"
export * from "./TablePromotions.vue?vue&type=script&lang=js&"
import style0 from "./TablePromotions.vue?vue&type=style&index=0&id=559544cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559544cc",
  null
  
)

export default component.exports